export const preloadPathsImages = [
  '/ice-banner-spin-{{rank}}.png',
  '/ice-flag-{{rank}}.png',
  '/ice-point-{{rank}}.png',
  '/ice-spin-{{rank}}.png',
  '/ice-spin-center-{{rank}}.png',
  '/ice-spin-icon-{{rank}}.png',
  '/ice-spin-icon-inactive.png',
  '/ice-spin-light.png',
];

export function generateLuckySpinPreload() {
  const ranks = ['Bronze', 'Diamond', 'Ruby'];
  let links: string[] = [];

  for (const rank of ranks) {
    for (const image of preloadPathsImages) {
      links.push(
        `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/lucky-spin/${rank}/png/${image.replace('{{rank}}', rank.toLowerCase())}`,
      );
    }
  }
  return (
    <>
      {links.map(link => (
        <link rel="preload" href={link} key={`lucky-spin-preload-${link}`} />
      ))}
    </>
  );
}
